import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import purchaseHistoryApi from "../../services/purchaseHistoryApi";
import { showErrorSnackbar } from "./snackbarSlice";

export const fetchUserOrders = createAsyncThunk("purchaseHistory/fetchUserOrders", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await purchaseHistoryApi.getUserOrdersList(data);
        if(response.status === 0){
            return response?.data;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
});

export const getUserBuyedPoints = createAsyncThunk("purchaseHistory/getUserBuyedPoints", async (data, { rejectWithValue, dispatch }) => {
    try{
        const response= await purchaseHistoryApi.getUserBuyedPoints(data);
        if(response.status === 0){
            return response?.data;
        }else{
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message);
        }
    }
    catch(error){
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message);
    }
})


const purchaseHistorySlice= createSlice({
    name : "purchaseHistory",
    initialState : {
        orders: [],
        error: null,
        ordersLoading: true,
        pointsLoading: true
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, fetchUserOrders, "orders", "error", "ordersLoading");
        handleAsyncThunk(builder, getUserBuyedPoints, "buyedPoints", "error", "pointsLoading");
    },
});

export default purchaseHistorySlice.reducer;